// @flow
import type {ApplicationState} from '../../state/types'

import React, {PureComponent} from 'react'
import {actions as routerActions} from 'redux-router5'
import {connect} from 'react-redux'

import {withTranslate} from '../translation'
import {placeSelectors} from '../../state/place/selectors'

import {phoneNumberToString} from './lib/phoneNumbersToString'
import {is24Hours} from './lib/is24hours'

import './place-detail.css'

type Props = {
  place: ?ServiceProvider,
  t: Function,
  backToHome: () => void,
}

class PlaceDetail extends PureComponent<Props> {
  render() {
    const {place, backToHome, t} = this.props

    if (!place) return null

    const phones:string[] = phoneNumberToString(place._embedded.phone_numbers)
    const isAllday = is24Hours(place) 
    
    return (
      <div className="place-detail">
        <h1>{place.name}</h1>
        <p>{place.address}</p>
        <ul className="phones">
          <li>{t('Place.phone')}</li>
          {phones.map((p, i) => {
            return (
              <li key={`phone-${i}`}><i className="fa fa-phone-square" aria-hidden="true"></i>{p}</li>
            )
          })}
        </ul>
        <p>{t('Place.hours.title' , {hours :place.details})}</p>
        {isAllday && (
          <div className="hours">
            <p>{t('Place.hours.allDay')}</p>
          </div>
        )}
        {place.location && (
          <a href={`/map?place=${place._links.self}`}><i className="fas fa-map-marked-alt"></i> {t('Place.mapLink')}</a>
        )}
        {place.website && (
          <p>website: <a href={place.website} target="_blank" rel="noopener noreferrer">{place.website}</a></p>
        )}
        {place.facebook && (
          <p>facebook: <a href={place.facebook} target="_blank" rel="noopener noreferrer">{place.facebook}</a></p>
        )}
        
        <button className="button is-dark" onClick={backToHome}>กลับไปยังแผนที่</button>
      </div>
    )
  }
}

const mapStateToProps = (state: ApplicationState):any => {
  return {
    place: placeSelectors.getPlace(state),
  }
}

const mapDispatchToProps = (dispatch: Function):any => {
  return {
    backToHome: () => {
      dispatch(routerActions.navigateTo('home'))
    },
  }
}

export default withTranslate(connect(mapStateToProps, mapDispatchToProps)(PlaceDetail))